module.exports = __webpack_public_path__ + "static/img/019_m0.c5b89b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/module/019_m0.png
// module id = j3hs
// module chunks = 0